export default () => {
  let isClient = false;
  if (typeof window !== 'undefined' && window.document) {
    isClient = true;
  }

  return isClient;
};
